<!--
  APill — 상태/태그 뱃지
  kinds: default / ok / warn / err / info / yellow
-->
<template>
  <span :class="['a-pill', `a-pill--${kind}`]">
    <span v-if="showDot" class="a-pill__dot" />
    <slot />
  </span>
</template>

<script>
export default {
  name: 'APill',
  props: {
    kind: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'ok', 'warn', 'err', 'info', 'yellow'].includes(v),
    },
    dot: { type: Boolean, default: null },
  },
  computed: {
    showDot() {
      // 명시되지 않았으면 시맨틱 종류만 dot 표시
      if (this.dot !== null) return this.dot;
      return ['ok', 'warn', 'err', 'info'].includes(this.kind);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  white-space: nowrap;
  font-family: $p-font-body;

  &__dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: currentColor;
  }

  &--default { background: $p-line-soft; color: $p-ink-mid; }
  &--ok      { background: $p-ok-soft;   color: $p-ok; }
  &--warn    { background: $p-warn-soft; color: $p-warn; }
  &--err     { background: $p-err-soft;  color: $p-err; }
  &--info    { background: $p-info-soft; color: $p-info; }
  &--yellow  { background: $p-point;     color: $p-ink; }
}
</style>
